import NUIAlert from '@/components/Alert/Alert'
import { currencyFormat } from '@/utils/currencyFormat'
import { getMonto, getMontoConsola } from '@/utils/getMonto'
import { Checkbox, Input, Link, Select, SelectItem } from '@nextui-org/react'
import { motion } from 'framer-motion'
import { FaRegClone, FaUser, FaIdBadge, FaStore } from 'react-icons/fa'
import React, { CSSProperties, useEffect, useState } from 'react'
import { useFormularioClienteContext } from '../hooks/useFormularioClienteContext'
import { webApiService } from '@/services'
import { useLocation, useParams } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { IConfigSeller } from '@/models/configSeller'
import { useSelector } from 'react-redux'
import { IUser } from '@/models/user.model'
import { FormularioClienteContextType } from '../context/FormularioClienteContext'
import { validateRUT } from '@/utils/validateRUT.util'

const REGIONES_CHILE = [
  'Región de Arica y Parinacota',
  'Región de Tarapacá',
  'Región de Antofagasta',
  'Región de Atacama',
  'Región de Coquimbo',
  'Región de Valparaíso',
  'Región Metropolitana',
  'Región del Libertador General Bernardo O\'Higgins',
  'Región del Maule',
  'Región de Ñuble',
  'Región del Biobío',
  'Región de La Araucanía',
  'Región de Los Ríos',
  'Región de Los Lagos',
  'Región de Aysén',
  'Región de Magallanes'
]

const StepThree: React.FC = () => {
  const { ctx, saveCtx } = useFormularioClienteContext() as FormularioClienteContextType
  const [data, setData] = useState<{ storeList: any[], loading: boolean }>({ storeList: [], loading: false })
  const userState = useSelector((store: { user: IUser }) => store.user)
  const location = useLocation()
  const { slug } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isConsolaFalabella = configSeller.config.s3.FOLDER_APP === 'ti_falabella' && ctx.data.sbu.id_sbu === 12
  const isConsolaPhantom = configSeller.config.s3.FOLDER_APP === 'ti_phantom' && ctx.data.sbu.id_sbu === 12
  const isConsolaMercadoLibreChile = configSeller.config.s3.FOLDER_APP === 'ti_mercado_libre_cl' && ctx.data.sbu.id_sbu === 12
  const isConsolaLiverpoolMexico = configSeller.config.s3.FOLDER_APP === 'ti_liverpool_mx' && ctx.data.sbu.id_sbu === 12
  const isCoppelMexico = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isHuaweiMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx'
  const isTelcelMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx'
  const isTelcelCorpMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx'
  const isHuaweiPeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_pe'
  const isHuaweiChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_cl'
  const isRipleyPeru = configSeller.config.s3.FOLDER_APP === 'ti_ripley_pe'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  const isRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl'
  const isHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe'
  const isOppoMexico = configSeller.config.s3.FOLDER_APP === 'ti_oppo'
  const isElektraMexico = configSeller.config.s3.FOLDER_APP === 'ti_elektra_mx'
  const isTecnobuyChile = configSeller.config.s3.FOLDER_APP === 'ti_tecnobuy_cl'
  const isLiverpoolMexico = configSeller.config.s3.FOLDER_APP === 'ti_liverpool_mx'
  console.log('🚀 ~ StepThree ~ isConsolaFalabella:', isConsolaFalabella)

  let isInIframe = false

  console.log('userState', userState)

  try {
    isInIframe = window.self !== window.top
  } catch (e) {
    isInIframe = true // No se puede acceder a window.top, asumimos que está en iframe
  }

  const loadData = async () => {
    setData({ ...data, loading: true })
    webApiService.getAllStoreBySeller(String(slug)).then(res => {
      if (res.success) {
        setData({ storeList: res.data, loading: false })
      }
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData({ ...data, loading: false })
    })
  }

  const getCampaign = () => {
    webApiService.activeContribution({ seller: String(slug), idSbu: ctx.data.sbu.id_sbu, idBrand: ctx.data.brand.id_brand, idModel: ctx.data.model.id_model }).then(res => {
      if (res.data !== null) {
        saveCtx({ ...ctx, data: { ...ctx.data, campaign: res.data } })
      }
    }).catch((error: any) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
    })
  }

  useEffect(() => {
    if (configSeller.config.s3.FOLDER_APP === 'ti_coppel' || configSeller.config.s3.FOLDER_APP === 'ti_macstore') loadData()
    if (configSeller.config.permisos.ENABLE_CONTRIBUTION === 1) getCampaign()
    return () => setData({ loading: false, storeList: [] })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }}
      className='py-6'
    >
      {/* Paso 1 */}
      <div className='container mb-6'>
        <div className='rounded-xl shadow-sm border border-gray-200 bg-white grid grid-cols-2'>
          <div className='p-4 border-r flex flex-col justify-center'>
            <div className='flex items-center gap-2 mb-2'>
              <span className='text-gray-400 text-lg'><FaRegClone /></span>
              <span className='font-semibold text-lg'>Verifica tu equipo</span>
            </div>
            <h5 className='font-bold text-xl'>{ctx.data.sbu.name}</h5>
            {
                ctx.data.sbu.id_sbu !== 2
                  ? (<p className='mb-0'>{ctx.data.model.model} - {ctx.data.capacity.capacity}</p>)
                  : (ctx.data.sbu.id_sbu === 2 && ctx.data.brand.id_brand === 1 && ctx.data.model.capacity === 0)
                      ? (<p className='mb-0'>{ctx.data.model.model}</p>)
                      : (ctx.data.sbu.id_sbu === 2 && ctx.data.brand.id_brand === 1 && ctx.data.model.capacity !== 0)
                          ? (<p className='mb-0'>{ctx.data.model.model} {ctx.data.cpu.name ? `- ${ctx.data.cpu.name}` : null}  - {ctx.data.screen.screen} - {ctx.data.ram.ram} ram - {ctx.data.capacity.capacity}</p>)
                          : (<p className='mb-0'>{ctx.data.cpu.name} - {ctx.data.screen.screen} - {ctx.data.ram.ram} ram - {ctx.data.capacity.capacity}</p>)
              }
            {
              (isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && ctx.data.devicePurcased && (
                <>
                  <h5 className='font-bold text-xl'>Dispositivo nuevo que quieres comprar</h5>
                  <p className='mb-0'>{ctx.data.devicePurcased.model}</p>
                </>
              )
            }
          </div>
          <div className='p-4 flex flex-col justify-center'>
            <p className='font-bold mb-1 text-end'>{(isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) ? <>Monto cashback máximo, sujeto a revisión<sup>*</sup></> : 'Monto de descuento'}</p>
            <p hidden={isConsolaFalabella || isConsolaPhantom || isConsolaMercadoLibreChile || isConsolaLiverpoolMexico} className='h5 font-black text-end'>{currencyFormat(getMonto(ctx.data, configSeller.config.s3.FOLDER_APP), import.meta.env.VITE_COUNTRY)}</p>
            <p hidden={!isConsolaFalabella && !isConsolaPhantom && !isConsolaMercadoLibreChile && !isConsolaLiverpoolMexico} className='h5 font-black text-end'>{currencyFormat(getMontoConsola(ctx.data, String(slug), Number(ctx.data.extraControls)), import.meta.env.VITE_COUNTRY)}</p>
            {
              ctx.data.campaign !== null && configSeller.config.permisos.ENABLE_CONTRIBUTION === 1
                ? (
                  <>
                    <div className='text-end' hidden={ctx.data.campaign === null || ctx.data.campaign === undefined}>
                      Monto extra campaña {ctx.data.campaign !== null ? `(${ctx.data.campaign.name})` : ''}: <span className='h5 font-black text-end'>{ctx.data.campaign !== null ? currencyFormat(ctx.data.campaign.amount, import.meta.env.VITE_COUNTRY) : currencyFormat(0, import.meta.env.VITE_COUNTRY)}</span>
                    </div>
                    <div className='text-end' hidden={ctx.data.campaign === null || ctx.data.campaign === undefined}>
                      Total : <span className='h5 font-black text-end'>{currencyFormat(Number(ctx.data.campaign.amount) + ((isConsolaFalabella || isConsolaPhantom || isConsolaMercadoLibreChile || isConsolaLiverpoolMexico) ? getMontoConsola(ctx.data, String(slug), Number(ctx.data.extraControls)) : getMonto(ctx.data, configSeller.config.s3.FOLDER_APP)), import.meta.env.VITE_COUNTRY)}</span>
                    </div>
                  </>
                  )
                : null
            }
            {
              (isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && ctx.data.devicePurcased && (
                <>
                  <p className='font-bold mb-1 text-end'>Monto cupón descuento Huawei</p>
                  <p className='text-end h5 font-black'>
                    {(() => {
                      // Los modelos sin monto llegan como null en MX y como el string 'null' en CL.
                      const val = String(ctx.data.devicePurcased.coupon_value ?? '').trim().replace(/\.00$/, '')
                      if (val === '' || val.toLowerCase() === 'null') return '5%'
                      return val.includes('%') ? val : currencyFormat(Number(val), import.meta.env.VITE_COUNTRY)
                    })()}
                  </p>
                </>
              )
            }
          </div>
        </div>
      </div>
      {/* Paso 2 */}
      <div className='container mb-6'>
        <div className='rounded-xl shadow-sm border border-gray-200 bg-white grid grid-cols-2 gap-4 p-4'>
          <div className='col-span-2 flex items-center gap-2 mb-2'>
            <span className='text-gray-400 text-lg'><FaUser /></span>
            <span className='font-semibold text-lg'>Datos cliente</span>
          </div>
          <div>
            <Input
              type='text'
              variant='bordered'
              label={(isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) ? 'Nombre del cliente' : 'Nombre'}
              value={ctx.data.name}
              fullWidth
              errorMessage={ctx.validation && ctx.data.name.trim() === '' ? 'Debe ingresar su nombre' : ''}
              isInvalid={ctx.validation && ctx.data.name.trim() === ''}
              autoComplete='off'
              onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, name: e.target.value } })}
            />
          </div>
          <div>
            <Input
              type='text'
              variant='bordered'
              label={(isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) ? 'Apellido del cliente' : 'Apellido'}
              value={ctx.data.lastname}
              fullWidth
              errorMessage={ctx.validation && ctx.data.lastname.trim() === '' ? 'Debe ingresar su apellido' : ''}
              isInvalid={ctx.validation && ctx.data.lastname.trim() === ''}
              autoComplete='off'
              onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, lastname: e.target.value } })}
            />
          </div>
          {
            !isLiverpoolMexico && (
              <div className={(isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) ? '' : 'col-span-2'}>
                <Input
                  type='email'
                  variant='bordered'
                  label='Correo electronico'
                  value={ctx.data.email}
                  fullWidth
                  errorMessage={ctx.validation && ctx.data.email.trim() !== '' && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email) ? 'Debe ingresar un correo válido' : ''}
                  isInvalid={ctx.validation && ctx.data.email.trim() !== '' && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email)}
                  autoComplete='off'
                  onBlur={() => saveCtx({ ...ctx, validation: ctx.data.email.trim() !== '' })}
                  onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, email: String(e.target.value) } })}
                />
              </div>
            )
          }
          {(isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && (
            <div>
              <Input
                type='text'
                variant='bordered'
                // En Huawei Online Perú el teléfono es obligatorio: se usa para coordinar el retiro del equipo.
                label={isHuaweiOnlinePeru ? 'Teléfono' : 'Teléfono (opcional)'}
                value={ctx.data.phone}
                inputMode='numeric'
                pattern='[0-9]*'
                maxLength={12}
                fullWidth
                errorMessage={isHuaweiOnlinePeru && ctx.validation && ctx.data.phone.trim() === '' ? 'Debe ingresar su teléfono' : ''}
                isInvalid={isHuaweiOnlinePeru && ctx.validation && ctx.data.phone.trim() === ''}
                autoComplete='off'
                // Al salir del campo vacío se prende la validación para que se vea el mensaje de error.
                onBlur={() => { if (isHuaweiOnlinePeru && ctx.data.phone.trim() === '') saveCtx({ ...ctx, validation: true }) }}
                onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, phone: e.target.value.replace(/\D/g, '') } })}
              />
            </div>
          )}
          {(isFalabellaChile || isRipleyChile) && (
            <div className='col-span-2'>
              <Input
                type='email'
                variant='bordered'
                label='Verificar correo electronico'
                value={ctx.data.email_validation}
                fullWidth
                errorMessage={
                ctx.validation && ctx.data.email_validation.trim() !== '' && (
                  !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email_validation)
                    ? 'Debe ingresar un correo válido'
                    : ctx.data.email !== ctx.data.email_validation
                      ? 'El correo no coincide'
                      : ''
                )
                }
                isInvalid={
                ctx.validation && ctx.data.email_validation.trim() !== '' && (
                  !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email_validation) ||
                  ctx.data.email !== ctx.data.email_validation
                )
                }
                autoComplete='off'
                onBlur={() => saveCtx({ ...ctx, validation: ctx.data.email_validation.trim() !== '' })}
                onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, email_validation: String(e.target.value) } })}
              />
            </div>
          )}
          {(isHuaweiOnlineChile) && (
            <div className='col-span-2'>
              <Select
                variant='bordered'
                label='Por favor cuéntanos desde que Region estas cotizando'
                aria-label='Por favor cuéntanos desde que Region estas cotizando'
                selectedKeys={ctx.data.region === '' ? [] : [ctx.data.region]}
                errorMessage={ctx.validation && ctx.data.region.trim() === '' ? 'Debe seleccionar una región' : ''}
                isInvalid={ctx.validation && ctx.data.region.trim() === ''}
                onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, region: e.target.value } })}
              >
                {REGIONES_CHILE.map((r) => (
                  <SelectItem key={r} textValue={r}>{r}</SelectItem>
                ))}
              </Select>
            </div>
          )}

          {isHuaweiOnlinePeru && (
            <div className='col-span-2'>
              <NUIAlert type='info'>
                <span className='font-bold'>Teléfono obligatorio.</span> Lo usamos para contactarte y coordinar el retiro de tu equipo.
              </NUIAlert>
            </div>
          )}

        </div>
      </div>
      {
            (configSeller.config.s3.FOLDER_APP === 'ti_coppel' || (configSeller.config.s3.FOLDER_APP === 'ti_macstore' && userState.id === 0)) && !isInIframe &&
              <div className='container mb-6'>
                <div className='rounded-xl shadow-sm border border-gray-200 bg-white grid grid-cols-2 gap-4 p-4'>
                  <div className='col-span-2 flex items-center gap-2 mb-2'>
                    <span className='text-gray-400 text-lg'><FaStore /></span>
                    <span className='font-semibold text-lg'>Tienda</span>
                  </div>
                  <div className='col-span-2 mt-2'>
                    <Select
                      variant='bordered'
                      size='lg'
                      aria-label='Select'
                      scrollShadowProps={{
                        isEnabled: true
                      }}
                      className='w-full'
                      placeholder='Seleccione una tienda'
                      isLoading={data.loading}
                      isDisabled={data.loading}
                      selectedKeys={ctx.data.id_store === 0 ? undefined : [String(ctx.data.id_store)]}
                      onChange={(e) => { saveCtx({ ...ctx, data: { ...ctx.data, id_store: Number(e.target.value) } }) }}
                    >
                      {data.storeList.map((s) => (
                        <SelectItem key={String(s.id)} textValue={`${isCoppelMexico ? s.seller_store_number + ' - ' : ''}${s.store.toUpperCase()}`}>
                          {isCoppelMexico ? s.seller_store_number + ' - ' : ''}{s.store.toUpperCase()}
                        </SelectItem>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
          }
      <div className='container mb-6'>
        <div className='rounded-xl shadow-sm border border-gray-200 bg-white grid grid-cols-2 gap-4 p-4'>
          {(
            ((configSeller.config.s3.FOLDER_APP === 'ti_macstore' && location.pathname.includes('backoffice'))) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_wom' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_oppo' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_elektra_mx' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_falabella' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_conecta_peru' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_claro' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_coppel' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_ripley_pe' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_paris' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_huawei_pe' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_huawei_cl' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx' && location.pathname.includes('backoffice')) ||
            ((configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl' || configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx' || configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe') && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_mercado_libre_cl' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_liverpool_mx' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_tecnobuy_cl' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_motorola' && location.pathname.includes('backoffice'))
          ) &&
        !isInIframe && (
          <>
            <div className='col-span-2 flex items-center gap-2 mb-2'>
              <span className='text-gray-400 text-lg'><FaIdBadge /></span>
              <span className='font-semibold text-lg'>{isLiverpoolMexico ? 'Datos del Vendedor' : 'ID vendedor'}</span>
            </div>
            <div hidden={isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru}>
              <Input
                type='text'
                variant='bordered'
                label='Nombre del vendedor'
                value={ctx.data.executiveName}
                fullWidth
                autoComplete='off'
                onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveName: e.target.value } })}
              />
            </div>
            <div hidden={isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru}>
              <Input
                type='text'
                variant='bordered'
                label='Apellido del vendedor'
                value={ctx.data.executiveLastname}
                fullWidth
                autoComplete='off'
                onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveLastname: e.target.value } })}
              />
            </div>
            {
              ((!isFalabellaChile && !isLiverpoolMexico) && (
                <div className='col-span-2'>
                  <Input
                    type='text'
                    variant='bordered'
                    label={(isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isLiverpoolMexico) ? 'Id vendedor' : isRipleyPeru ? 'Código del vendedor' : isMacstoreMexico ? 'Número de vendedor' : (isOppoMexico || isElektraMexico || isCoppelMexico) ? `${import.meta.env.VITE_LABEL_RUT} del vendedor` : isTecnobuyChile ? `${import.meta.env.VITE_LABEL_RUT} del vendedor (sin puntos y sin guion)` : `${import.meta.env.VITE_LABEL_RUT} del vendedor (sin puntos y con guion)`}
                    value={ctx.data.executiveRut}
                    errorMessage={
                    (isRipleyChile || isTecnobuyChile) && ctx.validation && ctx.data.executiveRut.trim() !== '' && !validateRUT(ctx.data.executiveRut.trim())
                      ? 'El RUT no es valido'
                      : ''
                    }
                    isInvalid={
                    (isRipleyChile || isTecnobuyChile) && ctx.validation && ctx.data.executiveRut.trim() !== '' && !validateRUT(ctx.data.executiveRut.trim())
                    }
                    fullWidth
                    autoComplete='off'
                    onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveRut: isTecnobuyChile ? e.target.value.replace(/-/g, '') : e.target.value } })}
                  />
                </div>
              ))
            }
            {
              (isFalabellaChile && (
                <div className='col-span-2'>
                  <Input
                    type='text'
                    variant='bordered'
                    label='Código de vendedor'
                    value={ctx.data.executiveId}
                    fullWidth
                    autoComplete='off'
                    onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveId: e.target.value } })}
                  />
                </div>
              ))
            }
          </>
          )}
          <div hidden={ctx.steps.current === 1 || ctx.steps.current === 0} className='col-span-2'>
            {
                configSeller.config.optin !== undefined && configSeller.config.optin.length > 0
                  ? configSeller.config.optin.map((optin: any) => (
                    <div key={optin.id} className='flex items-center my-4'>
                      <Checkbox
                        style={{ '--seller-color': `${configSeller.config.color}` } as CSSProperties}
                        classNames={{ wrapper: 'after:bg-[var(--seller-color)]' }}
                        size='sm'
                        isSelected={ctx.data.optins.find(o => o.id === optin.id)?.checked === undefined ? false : ctx.data.optins.find(o => o.id === optin.id)?.checked}
                        onChange={(e) => {
                          if (e.target.checked) { saveCtx({ ...ctx, data: { ...ctx.data, optins: [...ctx.data.optins, { id: optin.id, checked: e.target.checked }] } }) } else { saveCtx({ ...ctx, data: { ...ctx.data, optins: [...ctx.data.optins.filter(op => op.id !== optin.id)] } }) }
                        }}
                      >{optin.texto}
                      </Checkbox>
                      <Link href={optin.link} className='text-sm ml-1' target='_blank' rel='noreferrer'>Click aquí</Link>
                    </div>
                  ))
                  : null
                }
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default StepThree
